import DrawScreen from "./DrawScreen";

export default DrawScreen;